export const zhCN = {
  button: '按钮',
  ads: '广告',
  techClosed: '维护中',
  soon: '即将推出',
  noSeats: '无座位',
  events: '活动与&nbsp;娱乐项目',
  showAll: '显示全部',
  reset: '重置',
  filterEmptyResult: '请选择其他参数，我们将为您找到合适的娱乐项目！',
  showMore: '显示更多',
  fieldRequired: '此字段为必填字段',
  fieldPasswordError: '密码必须包含数字和拉丁字母，且长度不少于 8 个字符',
  fieldEmailError: '电子邮箱格式不正确',
  fieldPhoneError: '电话号码格式不正确',
  fieldBirthdayError: '出生日期不能晚于今天',
  fieldFormatError: '字段填写格式不正确',
  fieldEmailDuplicate: '此电子邮箱已注册',
  fieldPhoneDuplicate: '该电话号码已被注册',
  fieldEmailNotFound: '未找到使用此电子邮箱的用户',
  fieldPasswordMismatch: '密码不匹配',
  fieldBirthdayNotChild: '收件人不能超过18岁',
  fieldError: '字段填写错误',
  map: '地图',
  objectParams: '场馆参数',
  home: '首页',
  placement: '住宿类型',
  qrShowCard: '显示卡片',
  qrSubtitle: '在游乐园入口处出示二维码即可获得或消费积分',
  qrCard: '折扣卡',
  qrError: '卡片无法扫描？',
  qrAlert: '如果卡片无法读取，请提供下方的<br />唯一数字代码：',
  searchAllResults: '所有搜索结果',
  ourSocials: '我们的社交媒体',
  workPeriod: '营业时间设置',
  ourAddress: '我们的地址',
  phone: '电话',
  successRegTitle: '您已成功<br>注册！',
  successRegDesc: '我们期待您在"梦想岛"的光临',
  at: '在',
  from: '每日',
  to: '至',
  successRegHK: '参观Hello Kitty美容沙龙<br>需要为每位客人购买<br>游乐园门票',
  toMain: '返回首页',
  main: '首页',
  objects: '设施',
  profile: '个人资料',
  more: '更多',
};
